<div class="main-open-tab">
  <div class="contacts-container mt-4">
    <div class="d-grid contacts-header">
      <div class="d-flex align-items-center contact-title-wrapper">
        <img
          src="assets/svg/contact-icon.svg"
          width="20"
          class="contact-section-icon"
        />
        <h3 class="text-semibold contact-title">Contactos</h3>
      </div>
      <div class="d-flex justify-self-end gap-16">
        <button class="btn btn-round-outline">
          <img class="center-svg" src="assets/svg/reload-icon-org.svg" />
        </button>
        <button class="action-btn primary">
          <img
            src="assets/svg/plus-icon.svg"
            alt="Añadir nuevo"
            width="16"
            height="16"
          />
          Añadir nuevo
        </button>
      </div>
    </div>
    <div class="header-stats mt-2">
      <span>{{data.length}} elementos | Se actualizó hace 2 minutos</span>
    </div>
    <div class="prospectos-table mt-4">
      <table>
        <thead>
          <tr>
            <th class="checkbox-column text-center">
              <img src="assets/svg/checkline-icon.svg" />
            </th>
            <th>Nombre del contacto</th>
            <th>Teléfono</th>
            <th>Correo</th>
            <th>Cargo</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of contactos">
            <td class="checkbox-column">
              <input type="checkbox" (click)="$event.stopPropagation()" />
            </td>
            <td>{{ c.nombre }}{{c.apellido}}</td>
            <td>{{ c.telefono || '-' }}</td>
            <td>{{ c.correo || '-' }}</td>
            <td>{{ c.cargo || '-' }}</td>
            <div class="dropdown-container">
              <button class="dots-button">
                <svg class="dots-icon" viewBox="0 0 24 24">
                  <circle cx="12" cy="5" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="19" r="2" />
                </svg>
              </button>
              <div class="dropdown-menu">
                <button class="dropdown-item">Modificar</button>
                <button class="dropdown-item">Eliminar</button>
                <button class="dropdown-item">Cambiar propietario</button>
                <button class="dropdown-item">Modificar etiquetas</button>
              </div>
            </div>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="contact-table-footer text-center">
      <button class="btn-primary-outline-2">Ver todos los contactos</button>
    </div>
  </div>

  <div class="contacts-container mt-4">
    <div class="d-grid contacts-header">
      <div class="d-flex align-items-center contact-title-wrapper">
        <img
          src="assets/svg/opportunities-icon.svg"
          width="20"
          class="contact-section-icon"
        />
        <h3 class="text-semibold contact-title">Oportunidades</h3>
      </div>
      <div class="justify-self-end">
        <button class="action-btn primary">Crear nueva oportunidad</button>
      </div>
    </div>
        <div class="header-stats mt-2">
      <span>{{oportunidades.length}} elementos | Se actualizó hace 2 minutos</span>
    </div>
    <div class="prospectos-table mt-4">
      <table>
        <thead>
          <tr>
            <th class="checkbox-column text-center">
              <img src="assets/svg/checkline-icon.svg" />
            </th>
            <th>Nombre oportunidad</th>
            <th>Estado</th>
            <th>Monto</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of oportunidades">
            <td class="checkbox-column">
              <input type="checkbox" (click)="$event.stopPropagation()" />
            </td>
            <td>{{ c.nombre }}</td>
            <td>{{ c.estado?.nombre || '-' }}</td>
            <td>{{ c.importe_actual || '-' }}</td>
            <div class="dropdown-container">
              <button class="dots-button">
                <svg class="dots-icon" viewBox="0 0 24 24">
                  <circle cx="12" cy="5" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="19" r="2" />
                </svg>
              </button>
              <div class="dropdown-menu">
                <button class="dropdown-item">Modificar</button>
                <button class="dropdown-item">Eliminar</button>
                <button class="dropdown-item">Cambiar propietario</button>
                <button class="dropdown-item">Modificar etiquetas</button>
              </div>
            </div>
          </tr>
        </tbody>
      </table>
    </div>
        <div class="contact-table-footer text-center">
      <button class="btn-primary-outline-2">Ver todas las oportunidades</button>
    </div>
  </div>

  <div class="contacts-container mt-4">
    <div class="d-grid contacts-header">
      <div class="d-flex align-items-center contact-title-wrapper">
        <img
          src="assets/svg/stories-icon.svg"
          width="20"
          class="contact-section-icon"
        />
        <h3 class="text-semibold contact-title">Casos</h3>
      </div>
      <div class="justify-self-end">
        <button class="action-btn primary">Crear nuevo caso</button>
      </div>
    </div>
  </div>
</div>
